import { frontendURL } from '../../../helper/URLHelper';
import CondaKnowledge from './pages/Knowledge.vue';
import CondaDocuments from './pages/Documents.vue';
import CondaMotion from './pages/Motion.vue';
import CondaPresidential from './pages/Presidential.vue';
import CondaPlaybook from './pages/Playbook.vue';
import CondaSettings from './pages/Settings.vue';

const meta = {
  permissions: ['administrator'],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/conda/knowledge'),
    name: 'conda_knowledge',
    component: CondaKnowledge,
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/conda/documents'),
    name: 'conda_documents',
    component: CondaDocuments,
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/conda/personality'),
    name: 'conda_personality',
    component: CondaSettings,
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/conda/test-drive'),
    name: 'conda_test_drive',
    component: CondaMotion,
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/conda/review'),
    name: 'conda_review',
    component: CondaPresidential,
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/conda/playbook'),
    name: 'conda_playbook',
    component: CondaPlaybook,
    meta,
  },
];
